import { Button } from "antd"
import styles from "./index.module.less"

const FloatButton = props => {
  return <Button className={styles.floatingBtn} icon={props.icon} {...props} />
}
export default FloatButton
